export enum ReportType {
  payments = "payments",
  orders = "orders",
  unitsByHr = "units-by-hr",
}
